export default __webpack_public_path__ + "static/media/buddi-screen.8443bb7a.png";